module.exports = __webpack_public_path__ + "static/media/groupSuccessImg.898e57b3.svg";